<template>
  <div class="row mt-3">
    <div class="border-bottom mb-3">
      <h5 class="text-muted fw-light">
        <i class="ri-money-dollar-circle-line"></i>
        Detalle Pagos
      </h5>
    </div>
    <div class="form-group col-md-3">
      <label>Fecha pago inicial:*</label
      ><input
        type="date"
        class="form-control"
        name="fecha_pago_inicial"
        required=""
        autocomplete="off"
      />
    </div>
    <div class="form-group col-md-3">
      <label>Renta inicial*</label
      ><input
        type="tel"
        class="form-control"
        name="renta_inicial"
        placeholder="00.00"
        required=""
        autocomplete="off"
        @keydown="validateDecimal($event)"
      />
    </div>
    <div class="form-group col-md-3">
      <label>Mensualidad*</label
      ><input
        type="tel"
        class="form-control"
        name="mensualidad"
        placeholder="00.00"
        required=""
        autocomplete="off"
        @keydown="validateDecimal($event)"
      />
    </div>
    <div class="form-group col-md-3">
      <label>Valor Residual*</label
      ><input
        type="tel"
        class="form-control"
        name="valor_residual"
        required=""
        placeholder="00.00"
        autocomplete="off"
        @keydown="validateDecimal($event)"
      />
    </div>
    <div class="form-group col-md-3">
      <label>Fecha fin*</label
      ><input
        type="date"
        class="form-control"
        name="fecha_fin"
        required=""
        autocomplete="off"
      />
    </div>
    <div class="text-center mt-1">
      <button
        type="submit"
        class="btn btn-primary me-2 btn-sm"
        :disabled="loadingButton"
      >
        <span
          class="spinner-border spinner-border-sm"
          role="status"
          aria-hidden="true"
          v-if="loadingButton"
        ></span>
        Guardar
      </button>
      <router-link
        :to="{ name: 'contrato-compra-venta' }"
        class="active btn btn-danger text-white btn-sm"
        >Cancelar</router-link
      >
    </div>
  </div>
</template>

<script>
import useContratosStore from '@/store/contratos'
import { useGeneralStore } from '@/store/general';

export default {
  setup() {
    const { validateDecimal } = useGeneralStore();

    const { loadingButton } = useContratosStore();
    return { loadingButton, validateDecimal };
  },
};
</script>

<style></style>
